"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _ITCIC2TCcjs = require('./ITCIC2TC.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/button/button.tsx
var _dom = require('@ariakit/core/utils/dom');
var _react = require('react');
var TagName = "button";
var useButton = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useButton2(props) {
    const ref = _react.useRef.call(void 0, null);
    const tagName = _3BSDKDKDcjs.useTagName.call(void 0, ref, TagName);
    const [isNativeButton, setIsNativeButton] = _react.useState.call(void 0, 
      () => !!tagName && _dom.isButton.call(void 0, { tagName, type: props.type })
    );
    _react.useEffect.call(void 0, () => {
      if (!ref.current) return;
      setIsNativeButton(_dom.isButton.call(void 0, ref.current));
    }, []);
    props = {
      role: !isNativeButton && tagName !== "a" ? "button" : void 0,
      ...props,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref)
    };
    props = _ITCIC2TCcjs.useCommand.call(void 0, props);
    return props;
  }
);
var Button = _PTOCUU2Dcjs.forwardRef.call(void 0, function Button2(props) {
  const htmlProps = useButton(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useButton = useButton; exports.Button = Button;
